import { BlockQuoteWrapper } from "components/slices/BlockQuote";
import { CardWithImageWrapper } from "components/slices/CardWithImage";
import { CheckListWrapper } from "components/slices/CheckList";
import { CollapsibleWrapper } from "components/slices/Collapsible";
import { EmbedWrapper } from "components/slices/Embed";
import { IframeWrapper } from "components/slices/Iframe";
import { ImageWithContentWrapper } from "components/slices/ImageWithContent";
import { ImageWrapper } from "components/slices/Image";
import { LARGE, EXTRALARGE } from "shared/variables";
import { LinkedItemsWrapper } from "components/slices/LinkedItems";
import { MaxWidth } from "components/MaxWidth";
import { ReviewWrapper } from "components/slices/Review";
import { RichTextWrapper } from "components/slices/RichText";
import { SpacingSection } from "components/SpacingSection";
import { RegistrationFormWrapper } from "components/slices/RegistrationForm";

export const Slices = ({ data, uid }) => {
  const sliceSettings = {
    blockquote: { Component: BlockQuoteWrapper },
    card_with_image: { Component: CardWithImageWrapper },
    checklist: { Component: CheckListWrapper },
    collapsible: { Component: CollapsibleWrapper },
    embed: { Component: EmbedWrapper, spacing: LARGE },
    iframe: { Component: IframeWrapper, spacing: LARGE },
    image_with_content: {
      Component: ImageWithContentWrapper,
      size: EXTRALARGE,
      spacing: EXTRALARGE,
    },
    image: { Component: ImageWrapper, spacing: LARGE },
    linked_items: { Component: LinkedItemsWrapper, spacing: LARGE },
    review: { Component: ReviewWrapper, spacing: LARGE },
    rich_text: { Component: RichTextWrapper },
    registration_form: { Component: RegistrationFormWrapper },
  };

  return (
    <div>
      {data.map((slice, index) => {
        const { Component, spacing, size } = sliceSettings[slice.slice_type];

        if (Component) {
          return (
            <SpacingSection
              className={slice.slice_type}
              key={index}
              size={spacing}
            >
              <MaxWidth size={slice.primary.size || size}>
                <Component {...slice} uid={uid} />
              </MaxWidth>
            </SpacingSection>
          );
        }
      })}
    </div>
  );
};
